export default __webpack_public_path__ + "static/media/Quick_Actions_Filled_Active.5b2ef8fa.svg";